/* eslint-disable */
import React, { Component } from "react";
import cookie from "react-cookies";
import axios from "axios";
import { connect } from "react-redux";
import update from "immutability-helper";
import { validated } from "react-custom-validation";

/* import Form from "./Form"; */

import { apiUrl, baseUrl, ecommerceapiUrl } from "../../Helpers/Config";

import { showLoader, hideLoader, showAlert } from "../../Helpers/SettingHelper";

var qs = require("qs");
var Parser = require("html-react-parser");
var base64 = require("base-64");
class Login extends Component {
  constructor(props) {
    super(props);
    console.log(this.props, "this.propsthis.propsthis.props");
    var LoginType = this?.props?.match?.params || "";
    var clientID = this?.props?.match?.params || "";
    /*  LoginType = LoginType != undefined ? LoginType : "";
    clientID = clientID != undefined ? clientID : ""; */
    this.state = {
      companyEnableEpicSocial: cookie.load("companyEnableEpicSocial") || "",
      fields: {
        username: "",
        password: "",
      },
      error_msg: "",
      login_type: LoginType,
      client_id: clientID,
    };

    if (LoginType != "" && LoginType != "masteradmin") {
      location.href = baseUrl + "clientpanel/login";
    }
  }
  componentDidMount() {
    const companyEnableEpicSocial = this.state.companyEnableEpicSocial;
    if(companyEnableEpicSocial!=="") {
      //cookie.remove("companyEnableEpicSocial", { path: "/" });
    }
  }
  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { fields: { [field]: { $set: value } } }));
  };

  handleSignin = () => {
    const formPayload = this.state.fields;
    this.setState({ error_msg: "" });
    var postObject = {
      username: formPayload.username,
      password: formPayload.password,
      login_type: this.state.login_type,
      client_id: this.state.client_id,
    };
    showLoader("do_login", "class");

    axios
      .post(apiUrl + "client/login", postObject)
      .then((res) => {
        hideLoader("do_login", "class");

        if (res.data.status === "ok") {
          var ResulSet = res.data.result;
          cookie.save("companyID", base64.encode(ResulSet.company_id), {
            path: "/",
          });
          cookie.save("clientID", base64.encode(ResulSet.company_admin_id), {
            path: "/",
          });

          cookie.save("clientUnquieID", ResulSet.company_unquie_id, {
            path: "/",
          });
          cookie.save("clientCurrency", ResulSet.admin_currency, { path: "/" });
          cookie.save("clientLoginType", ResulSet.admin_type, { path: "/" });
          cookie.save("clientPerPage", ResulSet.admin_records_perpage, {
            path: "/",
          });
          cookie.save("clientAllowOutlet", ResulSet.user_permission_outlet, {
            path: "/",
          });
          cookie.save("clientFirstName", ResulSet.company_firstlast_name, {
            path: "/",
          });
          cookie.save("clientAccessToken", ResulSet.token, {
            path: "/",
          });
          cookie.save("enableEmailCampaign", ResulSet.enableEmailCampaign, {
            path: "/",
          });
          cookie.save("enableSMSCampaign", ResulSet.enableSMSCampaign, {
            path: "/",
          });
          cookie.save("companyEnableWhatsappCampaign", ResulSet.companyEnableWhatsappCampaign, {
            path: "/",
          });
          cookie.save("companyAllowAssignVoucher", ResulSet.companyAllowAssignVoucher, {
            path: "/",
          });
          cookie.save("companyPlans", ResulSet.companyPlans, {
            path: "/",
          });
          cookie.save("companyEnableSpinWheel", ResulSet.companyEnableSpinWheel, {
            path: "/",
          });
          cookie.save("companyEnableTimeSlotDateBased", ResulSet.companyEnableTimeSlotDateBased, {
            path: "/",
          });

          cookie.save("companysupabaseReservationUserName", ResulSet.companysupabaseReservationUserName, {
            path: "/",
          });
          cookie.save("companysupabaseReservationPassword", ResulSet.companysupabaseReservationPassword, {
            path: "/",
          });
          cookie.save("companyEnableReservation", ResulSet.companyEnableReservation, { path: "/" });

          cookie.save("companyEnableEpicEngage", ResulSet.companyEnableEpicEngage, { path: "/" });
          cookie.save("companysupabaseEngageUserName", ResulSet.companysupabaseEngageUserName, { path: "/" });
          cookie.save("companysupabaseEngagePassword", ResulSet.companysupabaseEngagePassword, { path: "/" });

          cookie.save("companyEnableEpicEngagev1", ResulSet.companyEnableEpicEngagev1, { path: "/" });
          cookie.save("companysupabaseEngagev1UserName", ResulSet.companysupabaseEngagev1UserName, { path: "/" });
          cookie.save("companysupabaseEngagev1Password", ResulSet.companysupabaseEngagev1Password, { path: "/" });

          cookie.save("companyEnableEpicSocial", ResulSet.companyEnableEpicSocial, { path: "/" });
          cookie.save("companysupabaseEpicSocialUserName", ResulSet.companysupabaseEpicSocialUserName, { path: "/" });
          cookie.save("companysupabaseEpicSocialPassword", ResulSet.companysupabaseEpicSocialPassword, { path: "/" });

          localStorage.setItem("epic_bearer_token", ResulSet.token);
          setTimeout(() => {
            location.href = baseUrl + "clientpanel/outlet";
          }, 500);
        }
      })
      .catch((e) => {
        hideLoader("do_login", "class");
        var errorMsg = e?.response?.data?.message || e.message;
        this.setState({ error_msg: errorMsg });
        setTimeout(() => {
          this.setState({ error_msg: "" });
        }, 5000);
      });
  };
  /* signin - end*/

  render() {
    return (
      <div className="position-relative">
        <div className="authentication-wrapper authentication-basic container-p-y">
          <div className="authentication-inner py-4">
            <div className="card p-2">
              <div className="app-brand justify-content-center mt-5">
                <a href="index.html" className="app-brand-link gap-2">
                  <span className="app-brand-logo demo">
                    <span>
                      <img src={"/epicpay.png"} alt="GoepicPay" />
                    </span>
                  </span>
                </a>
              </div>

              <div className="card-body mt-2">
                <Form
                  {...this.props}
                  fields={this.state.fields}
                  onChange={this.fieldChange}
                  onValid={this.handleSignin}
                  error_msg={this.state.error_msg}
                  onInvalid={() => console.log("Form invalid!")}
                />
              </div>
            </div>
            <img
              alt="mask"
              src="../../assets/img/illustrations/auth-basic-login-mask-light.png"
              className="authentication-image d-none d-lg-block"
              data-app-light-img="illustrations/auth-basic-login-mask-light.png"
              data-app-dark-img="illustrations/auth-basic-login-mask-dark.png"
            />
          </div>

          {this.state.companyEnableEpicSocial === "true" && (
            <iframe src={`${process.env.REACT_APP_EPICSOCIAL_URL}signout`} title="EpicSocial" style={{ display: "none" }} onLoad={this.handleIframeLoad} />
          )}
        </div>
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateTopProps, mapDispatchToProps)(Login);

const isEmpty = (value) => (value === "" ? "This field is required." : null);

function validationConfig(props) {
  const { username, password } = props.fields;

  return {
    fields: ["username", "password"],

    validations: {
      username: [[isEmpty, username]],
      password: [[isEmpty, password]],
    },
  };
}

class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pass_input_type: "password",
      newpass_input_type: "password",
      newcpass_input_type: "password",
      formType: "login",
      forgotEmail: "",
      forgotEmailError: "",
      forgotError: "",
      resetTime: 0,
      newpassword: "",
      newcpassword: "",
      errnewpassword: "",
      errnewcpassword: "",
      forgotOTP: "",
      firstotp: "",
      secondotp: "",
      thirdotp: "",
      fourthotp: "",
      fifthotp: "",
      sixthotp: "",
      userID: "",
    };
  }
  fieldChange_(name, e) {
    this.setState({ [name]: e.target.value });
  }
  changePassInputtype(type) {
    let passIntTyp = this.state[type];
    passIntTyp = passIntTyp == "password" ? "text" : "password";
    this.setState({ [type]: passIntTyp });
  }
  viewFormType(formType, e) {
    e.preventDefault();
    this.setState({ formType });
  }
  sendForgotPassword() {
    let error = 0;
    if (this.state.forgotEmail === "") {
      this.setState({ forgotEmailError: "This field is required." });
      error++;
    } else {
      this.setState({ forgotEmailError: "" });
    }
    if (error === 0) {
      var postObject = {
        forgotEmail: this.state.forgotEmail,
      };
      showLoader("do_forgotpwd", "class");

      axios
        .post(ecommerceapiUrl + "client/forgotpassword", postObject)
        .then((res) => {
          hideLoader("do_forgotpwd", "class");
          const showMsg = res?.data?.message || "";
          if (res.data.status === "ok") {
            var ResulSet = res.data.result;
            this.setState({ formType: "verifyotp", maskemail: this.state.forgotEmail, userID: ResulSet?.userID || "", resetTime: 60 }, () => {
              this.calculateTimer();
            });
          } else {
            showAlert("Error", showMsg, "error", "No");
          }
        })
        .catch((e) => {
          hideLoader("do_forgotpwd", "class");
          const errorMsg = e?.response?.data?.message || e.message;
          showAlert("Error", errorMsg, "error", "No");
        });
    }
  }
  onPasteCaptureHandler(e) {
    var clipboardData, pastedData;

    // Stop data actually being pasted into div
    e.stopPropagation();
    e.preventDefault();

    // Get pasted data via clipboard API
    clipboardData = e.clipboardData || window.clipboardData;
    pastedData = clipboardData.getData("Text");

    // Do whatever with pasteddata
    if (pastedData !== "") {
      var split = pastedData.split("");
      this.setState({ forgotOTP: pastedData, firstotp: split[0], secondotp: split[1], thirdotp: split[2], fourthotp: split[3], fifthotp: split[4], sixthotp: split[5] });
    }
  }
  changeText(otpkey, tabkey = "", e) {
    console.log(e.target, "e.target");
    this.setState({ [otpkey]: e.target.value }, () => {
      if (tabkey !== "") {
        $("#" + tabkey).focus();
      }
      var otp = this.state.firstotp + this.state.secondotp + this.state.thirdotp + this.state.fourthotp + this.state.fifthotp + this.state.sixthotp;
      this.setState({ forgotOTP: otp });
    });
  }
  handleVerifyOTP = () => {
    this.setState({ error_msg: "" });
    var postObject = {
      forgotEmail: this.state.forgotEmail,
      otp: this.state.forgotOTP,
    };
    showLoader("do_vefify_pwd", "class");

    axios
      .post(ecommerceapiUrl + "client/verifyOTP", postObject)
      .then((res) => {
        hideLoader("do_vefify_pwd", "class");
        const showMsg = res?.data?.message || "";
        if (res.data.status === "ok") {
          this.setState({ formType: "changepassword" });
        } else {
          showAlert("Error", showMsg, "error", "No");
        }
      })
      .catch((e) => {
        hideLoader("do_vefify_pwd", "class");
        const errorMsg = e?.response?.data?.message || e.message;
        showAlert("Error", errorMsg, "error", "No");
      });
  };

  changeNewPassword = () => {
    let error = 0;
    if (this.state.newpassword === "") {
      this.setState({ errnewpassword: "This field is required." });
      error++;
    } else {
      this.setState({ errnewpassword: "" });
    }
    if (this.state.newcpassword === "") {
      this.setState({ errnewcpassword: "This field is required." });
      error++;
    } else {
      if (this.state.newpassword !== this.state.newcpassword) {
        this.setState({ errnewcpassword: "Confirm password doesn't match" });
        error++;
      } else {
        this.setState({ errnewcpassword: "" });
      }
    }
    if (error === 0) {
      var postObject = {
        userID: this.state.userID,
        newPassword: this.state.newpassword,
      };
      showLoader("do_changepassword", "class");

      axios
        .post(ecommerceapiUrl + "client/updatePassword", postObject)
        .then((res) => {
          const showMsg = res?.data?.message || "";
          hideLoader("do_changepassword", "class");
          if (res.data.status === "ok") {
            this.setState({ formType: "login" });
            showAlert("Success", showMsg, "success", "No");
          } else {
            showAlert("Error", showMsg, "error", "No");
          }
        })
        .catch((e) => {
          hideLoader("do_changepassword", "class");
          const errorMsg = e?.response?.data?.message || e.message;
          showAlert("Error", errorMsg, "error", "No");
        });
    }
  };

  calculateTimer() {
    var $_this = this;
    setTimeout(function () {
      var resetTime = parseInt($_this.state.resetTime) - 1;
      $_this.setState({ resetTime: resetTime }, () => {
        if (resetTime > 0) {
          $_this.calculateTimer();
        }
      });
    }, 1000);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgUsername = "";
    let errMsgPassword = "";

    if ($validation.username.error.reason !== undefined) {
      errMsgUsername = $validation.username.show && <span className="error">{$validation.username.error.reason}</span>;
    }
    if ($validation.password.error.reason !== undefined) {
      errMsgPassword = $validation.password.show && <span className="error">{$validation.password.error.reason}</span>;
    }

    return (
      <div className="mb-3">
        {this.state.formType === "login" && (
          <div>
            <h4 className="mb-2 fw-semibold">Welcome to Epicware Wallet! 👋</h4>
            <p className="mb-4">Please sign-in to your account and start the adventure</p>
            <div
              className={errMsgUsername !== "" && errMsgUsername !== false ? "form-floating form-floating-outline mb-3 fv-plugins-bootstrap5-row-invalid" : "form-floating form-floating-outline mb-3"}
            >
              <input
                type="text"
                className={errMsgUsername !== "" && errMsgUsername !== false ? "form-control is-invalid" : "form-control"}
                id="username"
                name="username"
                placeholder="Enter your username"
                value={fields.username}
                {...$field("username", (e) => onChange("username", e.target.value))}
              />
              <label htmlFor="email">Username</label>
              {errMsgUsername !== "" && errMsgUsername !== false && (
                <div className="fv-plugins-message-container invalid-feedback">
                  <div data-field="email-username" data-validator="notEmpty">
                    Please enter username
                  </div>
                </div>
              )}
            </div>
            <div className="mb-3">
              <div className="form-password-toggle">
                <div className="input-group input-group-merge">
                  <div className={errMsgPassword !== "" && errMsgPassword !== false ? "form-floating form-floating-outline fv-plugins-bootstrap5-row-invalid" : "form-floating form-floating-outline"}>
                    <input
                      type={this.state.pass_input_type}
                      id="password"
                      className={errMsgPassword !== "" && errMsgPassword !== false ? "form-control is-invalid" : "form-control"}
                      name="password"
                      placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                      aria-describedby="password"
                      value={fields.password}
                      {...$field("password", (e) => onChange("password", e.target.value))}
                    />
                    <label htmlFor="password">Password</label>
                    {errMsgPassword !== "" && errMsgPassword !== false && (
                      <div className="fv-plugins-message-container invalid-feedback">
                        <div data-field="email-username" data-validator="notEmpty">
                          Please enter password
                        </div>
                      </div>
                    )}
                  </div>
                  <span className="input-group-text cursor-pointer" style={{ height: "49px" }} onClick={this.changePassInputtype.bind(this, "pass_input_type")}>
                    {this.state.pass_input_type == "password" ? <i className="mdi mdi-eye-off-outline"></i> : <i className="mdi mdi-eye-outline"></i>}
                  </span>
                </div>
              </div>
            </div>
            <div className="mb-3 d-flex justify-content-between">
              <div></div>
              {/* <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="remember-me"
            />
            <label className="form-check-label" htmlFor="remember-me">
              {" "}
              Remember Me{" "}
            </label>
          </div> */}
              <a href="/" onClick={this.viewFormType.bind(this, "forgotpassword")} className="float-end mb-1">
                <span>Forgot Password?</span>
              </a>
            </div>
            {this.props.error_msg !== "" && (
              <div className="alert alert-danger login-error" role="alert">
                {Parser(this.props.error_msg)}
              </div>
            )}
            <div className="mb-3">
              <button
                type="button"
                className="btn btn-primary d-grid w-100 do_login"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                Sign in
              </button>
            </div>
          </div>
        )}
        {this.state.formType === "forgotpassword" && (
          <div>
            <h4 className="mb-2 fw-semibold">Forgot Password</h4>
            <div className={this.state.forgotEmailError !== "" ? "form-floating form-floating-outline mb-3 fv-plugins-bootstrap5-row-invalid" : "form-floating form-floating-outline mb-3"}>
              <input
                type="text"
                className={this.state.forgotEmailError !== "" ? "form-control is-invalid" : "form-control"}
                id="username"
                name="username"
                placeholder="Enter your username"
                value={this.state.forgotEmail}
                onChange={this.fieldChange_.bind(this, "forgotEmail")}
              />
              <label htmlFor="email">Email</label>
              {this.state.forgotEmailError !== "" && (
                <div className="fv-plugins-message-container invalid-feedback">
                  <div data-field="email-username" data-validator="notEmpty">
                    {this.state.forgotEmailError}
                  </div>
                </div>
              )}
            </div>

            <div className="mb-3 d-flex justify-content-between">
              <div></div>
              <a href="/" onClick={this.viewFormType.bind(this, "login")} className="float-end mb-1">
                <span>Go Back</span>
              </a>
            </div>
            {this.state.forgotError !== "" && (
              <div className="alert alert-danger login-error" role="alert">
                {Parser(this.state.forgotError)}
              </div>
            )}
            <div className="mb-3">
              <button type="button" className="btn btn-primary d-grid w-100 do_forgotpwd" onClick={this.sendForgotPassword.bind(this)}>
                Send OTP
              </button>
            </div>
          </div>
        )}
        {this.state.formType === "verifyotp" && (
          <div className="card-body">
            <h4 className="mb-2 fw-semibold">Two Step Verification 💬</h4>
            <p className="text-start mb-4">
              We sent a verification code to your email. Enter the code from the email in the field below.
              <span className="fw-bold d-block mt-2">{this.props.maskemail}</span>
            </p>
            <p className="mb-0 fw-semibold">Type your 6 digit security code</p>

            <div className="mb-3">
              <div className="auth-input-wrapper d-flex align-items-center justify-content-sm-between numeral-mask-wrapper">
                <input
                  type="text"
                  className="form-control auth-input w-px-50 text-center numeral-mask text-center h-px-50 mx-1 my-2"
                  maxlength="1"
                  autofocus
                  onPasteCapture={this.onPasteCaptureHandler.bind(this)}
                  value={this.state.firstotp}
                  id="firstotp"
                  autoComplete="off"
                  onChange={this.changeText.bind(this, "firstotp", "secondotp")}
                />
                <input
                  type="text"
                  className="form-control auth-input w-px-50 text-center numeral-mask text-center h-px-50 mx-1 my-2"
                  maxlength="1"
                  value={this.state.secondotp}
                  id="secondotp"
                  autoComplete="off"
                  onChange={this.changeText.bind(this, "secondotp", "thirdotp")}
                />
                <input
                  type="text"
                  className="form-control auth-input w-px-50 text-center numeral-mask text-center h-px-50 mx-1 my-2"
                  maxlength="1"
                  value={this.state.thirdotp}
                  id="thirdotp"
                  autoComplete="off"
                  onChange={this.changeText.bind(this, "thirdotp", "fourthotp")}
                />
                <input
                  type="text"
                  className="form-control auth-input w-px-50 text-center numeral-mask text-center h-px-50 mx-1 my-2"
                  maxlength="1"
                  value={this.state.fourthotp}
                  id="fourthotp"
                  autoComplete="off"
                  onChange={this.changeText.bind(this, "fourthotp", "fifthotp")}
                />
                <input
                  type="text"
                  className="form-control auth-input w-px-50 text-center numeral-mask text-center h-px-50 mx-1 my-2"
                  maxlength="1"
                  value={this.state.fifthotp}
                  id="fifthotp"
                  autoComplete="off"
                  onChange={this.changeText.bind(this, "fifthotp", "sixthotp")}
                />
                <input
                  type="text"
                  className="form-control auth-input w-px-50 text-center numeral-mask text-center h-px-50 mx-1 my-2"
                  maxlength="1"
                  value={this.state.sixthotp}
                  id="sixthotp"
                  autoComplete="off"
                  onChange={this.changeText.bind(this, "sixthotp", "")}
                />
              </div>
            </div>
            <button className="btn btn-primary d-grid w-100 mb-3 do_vefify_pwd" onClick={this.handleVerifyOTP.bind(this)}>
              Verify OTP
            </button>
            <div className="text-center">
              {this.state.resetTime > 0 ? (
                <>{this.state.resetTime} Sec</>
              ) : (
                <>
                  Didn't get the code?
                  <a
                    href={void 0}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.$submit(onValid, onInvalid);
                    }}
                  >
                    {" "}
                    Resend{" "}
                  </a>
                </>
              )}
            </div>
          </div>
        )}
        {this.state.formType === "changepassword" && (
          <div>
            <h4 className="mb-2 fw-semibold">Change Password</h4>
            <div className="mb-3">
              <div className="form-password-toggle">
                <div className="input-group input-group-merge">
                  <div
                    className={
                      this.state.errnewpassword !== "" && this.state.errnewpassword !== false
                        ? "form-floating form-floating-outline fv-plugins-bootstrap5-row-invalid"
                        : "form-floating form-floating-outline"
                    }
                  >
                    <input
                      type={this.state.newpass_input_type}
                      id="password"
                      className={this.state.errnewpassword !== "" && this.state.errnewpassword !== false ? "form-control is-invalid" : "form-control"}
                      name="newpassword"
                      placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                      aria-describedby="newpassword"
                      value={this.state.newpassword}
                      onChange={this.fieldChange_.bind(this, "newpassword")}
                    />
                    <label htmlFor="password">Password</label>
                    {this.state.errnewpassword !== "" && this.state.errnewpassword !== false && (
                      <div className="fv-plugins-message-container invalid-feedback">
                        <div data-field="email-username" data-validator="notEmpty">
                          {this.state.errnewpassword}
                        </div>
                      </div>
                    )}
                  </div>
                  <span className="input-group-text cursor-pointer" style={{ height: "49px" }} onClick={this.changePassInputtype.bind(this, "newpass_input_type")}>
                    {this.state.newpass_input_type == "password" ? <i className="mdi mdi-eye-off-outline"></i> : <i className="mdi mdi-eye-outline"></i>}
                  </span>
                </div>
              </div>
            </div>
            <div className="mb-3">
              <div className="form-password-toggle">
                <div className="input-group input-group-merge">
                  <div
                    className={
                      this.state.errnewcpassword !== "" && this.state.errnewcpassword !== false
                        ? "form-floating form-floating-outline fv-plugins-bootstrap5-row-invalid"
                        : "form-floating form-floating-outline"
                    }
                  >
                    <input
                      type={this.state.newcpass_input_type}
                      id="password"
                      className={this.state.errnewcpassword !== "" && this.state.errnewcpassword !== false ? "form-control is-invalid" : "form-control"}
                      name="newcpassword"
                      placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                      aria-describedby="password"
                      value={fields.newcpassword}
                      onChange={this.fieldChange_.bind(this, "newcpassword")}
                    />
                    <label htmlFor="password">New Password</label>
                    {this.state.errnewcpassword !== "" && this.state.errnewcpassword !== false && (
                      <div className="fv-plugins-message-container invalid-feedback">
                        <div data-field="email-username" data-validator="notEmpty">
                          {this.state.errnewcpassword}
                        </div>
                      </div>
                    )}
                  </div>
                  <span className="input-group-text cursor-pointer" style={{ height: "49px" }} onClick={this.changePassInputtype.bind(this, "newcpass_input_type")}>
                    {this.state.newcpass_input_type == "password" ? <i className="mdi mdi-eye-off-outline"></i> : <i className="mdi mdi-eye-outline"></i>}
                  </span>
                </div>
              </div>
            </div>
            <div className="mb-3 d-flex justify-content-between">
              <div></div>
              <a href="/" onClick={this.viewFormType.bind(this, "login")} className="float-end mb-1">
                <span>Back to login</span>
              </a>
            </div>
            <div className="mb-3">
              <button type="button" className="btn btn-primary d-grid w-100 do_changepassword" onClick={this.changeNewPassword.bind(this)}>
                Change Password
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}
Form = validated(validationConfig)(Form);
